/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, Form, FormGroup, FormFeedback, Label, Input, Col } from 'reactstrap'

import Select from 'react-select'

import { AppContext } from  '../../AppContext'

class WebsiteProfile extends React.Component
{
  componentDidMount()
  {
    this.fetchAdminProfile();
    this.getTablespaces();
    this.getSystemPermissions();
    this.setState({passwordStrength: this.context.websiteProfile.passwordStrength});
  }

  constructor(props)
  {
    super();

    this.state =
    {
      profileName: '',
      profileNameValid: undefined,
      websiteRoot: '',
      websiteRootValid: undefined,
      streamProxyPrefix: '',
      streamProxyPrefixValid: undefined,
      downloadProxyPrefix: '',
      downloadProxyPrefixValid: undefined,
      allowNewUsers: '',
      sslEnabled: '',
      defaultLobTablespace: '',
      defaultLobTablespaceValid: undefined,
      documentationLink: '',
      documentationValid: undefined,
      secureWeblinkWebpage: '',
      secureWeblinkWebpageValid: undefined,
      updateButtonDisabled: true,
      sharingEnabled: '',
      tablespaces: undefined,
      signupPageEnabled: '',
      signupPageEnabledDisabled: true,
      systemPermissions: [],
      grantedByDefault: [],
      tempFileHandlingEnabled: 'N',
      tempFileExtensions: [],
      captureAccessDetail: ''
    }

    this.resetValues = this.resetValues.bind(this);
    this.updateWebsiteProfile = this.updateWebsiteProfile.bind(this);
    this.selectTSpaceHandler = this.selectTSpaceHandler.bind(this);
    this.toggleAllowNewUsers = this.toggleAllowNewUsers.bind(this);
    this.grantedByDefaultChanged = this.grantedByDefaultChanged.bind(this);
    this.passwordStrengthChanged = this.passwordStrengthChanged.bind(this);
    this.setTempFileExtensions = this.setTempFileExtensions.bind(this);
  }

  async fetchAdminProfile()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getSystemSettings');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading website profile');

    let tempFileExtensions = '';
    for (let x = 0; x < result.jsonData.tempFileExtensions.length; x++)
    {
      if ('' !== tempFileExtensions) tempFileExtensions += ',';
      tempFileExtensions += result.jsonData.tempFileExtensions[x];
    }

    this.setState(
    {
      websiteRoot: result.jsonData.websiteRootAddress,
      websiteRootValid: true,
      streamProxyPrefix: result.jsonData.streamProxyPrefix,
      streamProxyPrefixValid: true,
      downloadProxyPrefix: result.jsonData.downloadProxyPrefix,
      downloadProxyPrefixValid: true,
      allowNewUsers: result.jsonData.allowNewUsers,
      sslEnabled: result.jsonData.sslEnabled,
      defaultLobTablespace: { tablespaceName: result.jsonData.defaultLobTablespace },
      defaultLobTablespaceValid: true,
      documentationLink: result.jsonData.documentationLink,
      documentationValid: true,
      secureWeblinkWebpage: result.jsonData.secureWeblinkWebpage,
      secureWeblinkWebpageValid: true,
      sharingEnabled: result.jsonData.sharingEnabled,
      profileName: result.jsonData.profileName,
      profileNameValid: true,
      updateButtonDisabled: true,
      signupPageEnabled: result.jsonData.signupPageEnabled,
      signupPageEnabledDisabled: (result.jsonData.allowNewUsers === 'Y' ? false : true),
      tempFileHandlingEnabled: result.jsonData.tempFileHandlingEnabled,
      tempFileExtensions: tempFileExtensions,
      captureAccessDetail: result.jsonData.captureAccessDetail
    });

  }

  async getSystemPermissions()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getSystemPermissions');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting system permissions');

    if (null !== result.jsonData.systemPermissions)
    {
      let grantedByDefault = [];
      for (let x = 0; x < result.jsonData.systemPermissions.length; x++)
        if ('Y' === result.jsonData.systemPermissions[x].grantedByDefault) grantedByDefault.push(result.jsonData.systemPermissions[x]);
  
      this.setState({ systemPermissions: result.jsonData.systemPermissions, grantedByDefault: grantedByDefault });
    }
  }

  async getTablespaces()
  {

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getTablespaceList');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving tablespace list');

    if (null !== result.jsonData.tablespaceList) this.setState({tablespaces: result.jsonData.tablespaceList});
  }

  async grantedByDefaultChanged(grantedByDefault, actionMetaD)
  {
    this.setState({grantedByDefault: grantedByDefault});

    let bodyData = {}

    if ('select-option' === actionMetaD.action)
    {
      bodyData.permissionId = actionMetaD.option.permissionId;
      bodyData.grantedByDefault = 'Y';
    }
    else
    {
      bodyData.permissionId = actionMetaD.removedValue.permissionId;
      bodyData.grantedByDefault = 'N';
    }

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'updateSystemPermission', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error updating system permission');

    this.context.postNotification('info', 'Website profile updated.');
  }

  passwordStrengthChanged(strength)
  {
    this.setState({passwordStrength: strength, updateButtonDisabled: false});
  }

  render()
  {
    let valueRequired = 'A value is required for this field.';
    let signupDisabled = ('N' === this.context.websiteProfile.smtpEnabled || 'N' === this.context.websiteProfile.allowNewUsers ? 
      'New users not allowed and/or outbound SMTP Email disabled.' : null);

    return(
      <div>
        <Form onSubmit={(event) => this.updateWebsiteProfile(event)}>
          <FormGroup row style={{paddingTop: "10px"}}>
            <Label for="profileName" sm="2">Profile Name</Label>
            <Col sm="3">
              <Input type="text" id="profileName" placeholder='(e.g. Acme Co. Secure Object Vault)' 
                value={this.state.profileName} onChange={this.requiredField.bind(this, 'profileName')}
                invalid={(undefined === this.state.profileNameValid ? undefined : !this.state.profileNameValid)} 
                valid={(undefined === this.state.profileNameValid ? undefined : this.state.profileNameValid)} 
              />
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for='sslEnabled' sm="2" >SSL Enabled?</Label>
            <Col sm="3" >
              <Input type="checkbox" id="sslEnabled" onChange={this.toggleCheckBox.bind(this, 'sslEnabled')} 
                checked={'Y' === this.state.sslEnabled ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}/>
            </Col>
          </FormGroup>
          <FormGroup row style={{paddingTop: "10px"}}>
            <Label for="websiteRoot" sm="2">Website Root Address</Label>
            <Col sm="3">
              <Input type="text" id="websiteRoot" placeholder='(e.g. cloud.acme.com)' 
                value={this.state.websiteRoot} onChange={this.requiredField.bind(this, 'websiteRoot')}
                invalid={(undefined === this.state.websiteRootValid ? undefined : !this.state.websiteRootValid)} 
                valid={(undefined === this.state.websiteRootValid ? undefined : this.state.websiteRootValid)} 
              />
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
            </Col>
          </FormGroup>
        { false && /* disabled for now... */
          <FormGroup row>
            <Label for="streamProxyPrefix" sm="2">Streaming HTTP Proxy Prefix</Label>
            <Col sm="3">
              <Input type="text" id="streamProxyPrefix" placeholder="(e.g. streaming)..." 
                invalid={(undefined === this.state.streamProxyPrefixValid ? undefined : !this.state.streamProxyPrefixValid)} 
                valid={(undefined === this.state.streamProxyPrefixValid ? undefined : this.state.streamProxyPrefixValid)} 
                value={this.state.streamProxyPrefix} onChange={this.requiredField.bind(this, 'streamProxyPrefix')}/>
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
            </Col>
          </FormGroup>
        }
        { false && /* disabled for now... */
          <FormGroup row>
            <Label for='downloadProxyPrefix' sm="2">Download HTTP Proxy Prefix</Label>
            <Col sm="3">
              <Input type="text" id="downloadProxyPrefix" placeholder="(e.g. download)..."
                invalid={(undefined === this.state.streamProxyPrefixValid ? undefined : !this.state.streamProxyPrefixValid)} 
                valid={(undefined === this.state.streamProxyPrefixValid ? undefined : this.state.streamProxyPrefixValid)} 
                value={this.state.downloadProxyPrefix} onChange={this.requiredField.bind(this, 'downloadProxyPrefix')}/>
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
            </Col>
          </FormGroup>
        }          
          <FormGroup row>
            <Label sm='2'>Constructed Root Addresses</Label>
            <Col style={{paddingTop: "5px"}} sm='6'>
              {'Y' === this.state.sslEnabled ? 'https://' : 'http://'}{this.state.websiteRoot}/{this.state.streamProxyPrefix} |&nbsp;
              {'Y' === this.state.sslEnabled ? 'https://' : 'http://'}{this.state.websiteRoot}/{this.state.downloadProxyPrefix}
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for='defaultLobTablespace' sm="2">Default LOB Tablespace</Label>
            <Col sm="3">
              <Select id='defaultLobTablespace' value={this.state.defaultLobTablespace} options={this.state.tablespaces} 
                getOptionLabel={option => option.tablespaceName} getOptionValue={option => option.tablespaceName}
                onChange={this.selectTSpaceHandler} isClearable={false} />
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
            </Col>
          </FormGroup>
        { false && /* disabled for now... */
          <FormGroup row>
            <Label for='documentationLink' sm="2">Documentation Link</Label>
            <Col sm="3">
              <Input type="text" id="documentationLink" placeholder="https://cloud-eval.asteriondb.com/objectVault/usersGuide"
                invalid={(undefined === this.state.documentationValid ? undefined : !this.state.documentationValid)} 
                valid={(undefined === this.state.documentationValid ? undefined : this.state.documentationValid)} 
                value={this.state.documentationLink} onChange={this.requiredField.bind(this, 'documentationLink')}/>
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
            </Col>
          </FormGroup>
        }
        { false && /* disabled for now... */
          <FormGroup row>
            <Label for='secureWeblinkWebpage' sm="2">Secure Weblink Webpage</Label>
            <Col sm="3">
              <Input type="text" id="secureWeblinkWebpage" placeholder="secureWeblink"
                invalid={(undefined === this.state.secureWeblinkWebpageValid ? undefined : !this.state.secureWeblinkWebpageValid)} 
                valid={(undefined === this.state.secureWeblinkWebpageValid ? undefined : this.state.secureWeblinkWebpageValid)} 
                value={this.state.secureWeblinkWebpage} onChange={this.requiredField.bind(this, 'secureWeblinkWebpage')}/>
              <FormFeedback valid={false}>{valueRequired}</FormFeedback>
              {'Y' === this.state.sslEnabled ? 'https://' : 'http://'}{this.state.websiteRoot}/{this.state.secureWeblinkWebpage}
            </Col>
          </FormGroup>
        }
          <FormGroup row>
            <Label for='sharingEnabled' sm="2" >Sharing Enabled?</Label>
            <Col sm="3" >
              <Input type="checkbox" id="sharingEnabled" onChange={this.toggleCheckBox.bind(this, 'sharingEnabled')} 
                checked={'Y' === this.state.sharingEnabled ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}/>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for='captureDetails' sm="2" >Capture Access Detail?</Label>
            <Col sm="3" >
              <Input type="checkbox" id="captureDetails" name="captureDetails" onChange={this.toggleCheckBox.bind(this, 'captureAccessDetail')}
                checked={'Y' === this.state.captureAccessDetail ? 'checked' : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}
                title="Checking this box will cause the detail for all gateway access operations to be captured."/>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for='allowNewUsers' sm="2" >Allow New Users?</Label>
            <Col sm="3" >
              <Input type="checkbox" id="allowNewUsers" name="allowNewUsers" onChange={this.toggleAllowNewUsers}
                checked={'Y' === this.state.allowNewUsers ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}/>
            </Col>
          </FormGroup>
        { false && /* disabling this, for now... */
          <span title={signupDisabled} >
            <FormGroup row>
              <Label for='signupPageEnabled' sm="2" >Signup Page Enabled?</Label>
              <Col sm="3" >
                <Input type="checkbox" id="signupPageEnabled" name="signupPageEnabled" onChange={this.toggleCheckBox.bind(this, 'signupPageEnabled')}
                  checked={'Y' === this.state.signupPageEnabled ? "checked" : ''} style={{marginLeft: 0, marginTop: '0.7rem'}}
                  disabled={this.state.signupPageEnabledDisabled}
                />
              </Col>
            </FormGroup>
          </span>            
        }
          <FormGroup row>
            <Label  sm="2">Password Strength</Label>
            <Col sm="1" style={{paddingTop: "5px"}}>
                <Label check>
                  <Input type="radio" name="passwordStrength" checked={(2 === this.state.passwordStrength ? 'checked' : '')} 
                    onChange={() => this.passwordStrengthChanged(2)} />
                  &nbsp;Average
                </Label>
            </Col>
            <Col sm="1" style={{paddingTop: "5px"}}>
              <Label check>
                <Input type="radio" name="passwordStrength" checked={(3 === this.state.passwordStrength ? 'checked' : '')} 
                  onChange={() => this.passwordStrengthChanged(3)} />
                &nbsp;Strong
              </Label>
            </Col>
              <Col sm="1" style={{paddingTop: "5px"}}>
              <Label check>
                <Input type="radio" name="passwordStrength" checked={(4 === this.state.passwordStrength ? 'checked' : '')} 
                  onChange={() => this.passwordStrengthChanged(4)} />
                &nbsp;Very Strong
              </Label>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for='enabledByDefault' sm="2" >Default Permissions</Label>
            <Col sm="3" >
              <Select id='enabledByDefault' value={this.state.grantedByDefault} options={this.state.systemPermissions} 
                onChange={this.grantedByDefaultChanged} isMulti getOptionValue={option => option.permission} 
                getOptionLabel={option => option.permission} closeMenuOnSelect={false} isClearable={false}
                placeholder={'Set default permissions...'} className="basic-multi-select" classNamePrefix="select"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm="2">
              <Label check for="tempFileHandlingEnabled">Enable temporary file handling?</Label>
            </Col>
            <Col sm="1">
              <Input type="checkbox" name="tempFileHandlingEnabled" onChange={this.toggleCheckBox.bind(this, 'tempFileHandlingEnabled')} 
                  checked={('Y' === this.state.tempFileHandlingEnabled)}/> 
            </Col>
          </FormGroup>
          <FormGroup row >
            <Col sm="2">
              <Label check for="tempFileHandlingEnabled">Temporary file extensions</Label>
            </Col>
            <Col sm="3">
              <Input title="Specify the allowed temporary file extensions separated by a comma (e.g. temp,tmp)" type="text" 
                placeholder="<file-extensions separated by commas>" value={this.state.tempFileExtensions} 
                onChange={this.setTempFileExtensions} disabled={'Y' === this.state.tempFileHandlingEnabled ? false : true}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col sm={{ offset: 2, size: 2}}>
              <Button type="submit" color="primary" disabled={this.state.updateButtonDisabled}>Update</Button>
              &nbsp;
              <Button id="cancelB" color="secondary" onClick={this.resetValues}>Reset</Button>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }

  requiredField(field, event)
  {
    let valid = ("" === event.target.value ? false : true);
    this.setState({[event.target.id]: event.target.value, [event.target.id + 'Valid']: valid, updateButtonDisabled: !valid});
  }

  resetValues()
  {
    this.fetchAdminProfile();
    this.setState({passwordStrength: this.context.websiteProfile.passwordStrength});
  }

  selectTSpaceHandler(selectedTablespace, actionMetaD)
  {
    if (null === selectedTablespace) return;
    this.setState({defaultLobTablespace: selectedTablespace, updateButtonDisabled: false});
  }

  setTempFileExtensions(event)
  {
    this.setState({tempFileExtensions: event.target.value, buttonsDisabled: false});
  }

  toggleAllowNewUsers()
  {
    let allowNewUsers = (this.state.allowNewUsers === 'Y' ? 'N' : 'Y');
    let signupPageEnabledDisabled = (allowNewUsers === 'Y' ? false : true);
    let signupPageEnabled = (signupPageEnabledDisabled ? 'N' : this.state.signupPageEnabled);
    this.setState(
    {
      allowNewUsers: allowNewUsers, 
      signupPageEnabledDisabled: signupPageEnabledDisabled,
      signupPageEnabled: signupPageEnabled,
      updateButtonDisabled: false
    });
  }

  toggleCheckBox(field)
  {
    let checkBox = this.state[field];
    if ('Y' === checkBox)
      checkBox = 'N';
    else
      checkBox = 'Y';

    this.setState({[field]: checkBox, updateButtonDisabled: false});
  }

  async updateWebsiteProfile(event)
  {
    event.preventDefault();

    if (!this.state.websiteRootValid || !this.state.streamProxyPrefixValid || !this.state.downloadProxyPrefixValid)
      return this.context.postNotification('info', 'Correct the errors on the page.');

    this.setState({updateButtonDisabled: true});

    let bodyData = {};
    bodyData.profileName = this.state.profileName;
    bodyData.websiteRootAddress = this.state.websiteRoot;
    bodyData.sslEnabled = this.state.sslEnabled;
    bodyData.streamProxyPrefix = this.state.streamProxyPrefix;
    bodyData.downloadProxyPrefix = this.state.downloadProxyPrefix;
    bodyData.allowNewUsers = this.state.allowNewUsers;
    bodyData.defaultLobTablespace = this.state.defaultLobTablespace.tablespaceName;
    bodyData.sharingEnabled = this.state.sharingEnabled;
    bodyData.documentationLink = this.state.documentationLink;
    bodyData.signupPageEnabled = this.state.signupPageEnabled;
    bodyData.secureWeblinkWebpage = this.state.secureWeblinkWebpage;
    bodyData.passwordStrength = this.state.passwordStrength;
    bodyData.captureAccessDetail = this.state.captureAccessDetail;
    bodyData.tempFileHandlingEnabled = this.state.tempFileHandlingEnabled;
    bodyData.tempFileExtensions = this.state.tempFileExtensions.split(',');

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'updateObjectVaultProfile', bodyData);
    if ('success' !== result.status)
    {
      this.setState({updateButtonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error updating website profile');
    } 
    
    this.context.postNotification('info', 'Website profile updated.');
    let appContext = this.context;
    appContext.fetchWebsiteProfile(true);
  }
}

WebsiteProfile.contextType = AppContext;

export default WebsiteProfile